module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-loop-ce453d3f46e6c16f62f147acade9daa4.svg";